import Rule from '../Rule'

export default class RuleDepends extends Rule {
  constructor ({ value, customAttribute, data, parameters }) {
    super({ value, customAttribute })
    this.data = data
    this.dataAttribute = parameters
  }
}
